import { Schedule } from "@/shared/api";
import { getTime, isUTC } from "@/shared/helpers/datetime";

export const hasWrongDatetime = (schedule: Schedule) =>
  !isUTC(schedule.from_datetime) ||
  (schedule.to_datetime && !isUTC(schedule.to_datetime));

export const findCurrentSchedule = (
  schedules: Schedule[],
  currentTime: number
): Schedule | null => {
  for (const schedule of schedules) {
    if (hasWrongDatetime(schedule)) {
      throw new Error("from_datetime or to_datetime is not in UTC format");
    }

    if (schedule.from_datetime && !schedule.to_datetime) {
      if (currentTime >= getTime(schedule.from_datetime)) {
        return schedule;
      }
    }

    if (schedule.from_datetime && schedule.to_datetime) {
      if (
        currentTime >= getTime(schedule.from_datetime) &&
        currentTime <= getTime(schedule.to_datetime)
      ) {
        return schedule;
      }
    }
  }

  return null;
};
